<form
  (onSubmit)="onSubmit()"
  title="VOTRE PORTFEUILLE SUR MESURE "
  [formGroup]="form"
>
  <form-wrapper>
    <pr-color-panel [display]="allocationPanel?.display">
      <pr-panel-body clazz="pam">
        <pr-label [name]="allocationPanel?.icon" [width]="18" [height]="18">{{
          allocationPanel?.text
        }}</pr-label>
      </pr-panel-body>
    </pr-color-panel>

    <div class="mbl text-center">
      <span>Répartition par : </span>
      <pr-radio
        [choices]="[
          ['PARTS', 'Part(s)', true, false],
          ['PERCENT', 'Pourcentage', true, false],
        ]"
        (onSelectChoice)="toggleColumnType($event)"
      >
      </pr-radio>
    </div>
    <div class="row">
      <div class="col-md-12">
        <pr-table-form
          #tableForm
          [formGroup]="form.get('scpis')"
          [addButtonLabel]="'Ajouter une nouvelle SCPI'"
          swiperMinWidth="300"
          [columnsDefinition]="currentColumnDefinition"
          [addListOptions]="scpiList"
          [formatTable]="formatTableDataFunction()"
          (optionSelected)="newOptionLogic()"
          [createModelDefinition]="createModel.bind(this)"
          [hasAddButton]="false"
        >
        </pr-table-form>
        <pr-button
          (click)="setQuestionStep()"
          display="neutral"
          rightIcon="add"
          tooltip="Ajouter une nouvelle SCPI"
          label="Ajouter une nouvelle SCPI"
        ></pr-button>
      </div>
    </div>
    <pr-color-panel [display]="riskNote?.display" class="mt-1">
      <pr-panel-body clazz="pam">
        <pr-label [name]="riskNote?.icon" [width]="18" [height]="18">{{
          riskNote?.text
        }}</pr-label>
      </pr-panel-body>
    </pr-color-panel>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
